const stoughton = {
  accesKey: 'acdeeb8c-f1d1-4604-a9fb-8adb9f9d652c',
  customerId: '2511',
  transactionId: '33885',
  cartId: '1_C249188',
  stoughtonPaymentDev: 'https://paymentsuat.unibank.com/remotetransaction/RTI.aspx',
  stoughtonPaymentProd: 'https://unipaygold.unibank.com/remotetransaction/RTI.aspx',
  stoughtonPostBack: 'https://us-web.apigw.recyclecoach.com/bulk/postback_payment_stoughton'
};

export default stoughton;
